import React from 'react';
import i18n from 'i18next';
import {
  Navigate,
} from 'react-big-calendar';

import {
  Button,
  Select,
} from 'web-components';
import {
  Flex,
  Text,
} from 'web-styled';

type Props = {
  label: string,
  clients: Array,
  calendarSelectedUser: string,
  onFilter: { (): void },
  onNavigate: { (): void },
  onNewWorkoutClick: { (): void },
};

export default ({
  onNavigate,
  label,
  onNewWorkoutClick,
  onFilter,
  clients,
  calendarSelectedUser,
}: Props) => (
  <Flex
    align="center"
    justify="space-between"
    padding="10px"
  >
    <Flex align="center" spacing={40}>
      <Flex align="center" spacing={10}>
        <Button
          ghost
          circled
          appearance="primary"
          icon="fas fa-chevron-left"
          onClick={() => onNavigate(Navigate.PREVIOUS)}
        />
        <Button
          ghost
          circled
          appearance="primary"
          icon="fas fa-chevron-right"
          onClick={() => onNavigate(Navigate.NEXT)}
        />
      </Flex>
      <Text size="30px">{label}</Text>
    </Flex>
    <Button
      appearance="success"
      onClick={onNewWorkoutClick}
    >
      {`${i18n.format(i18n.t('schedule.workout'), 'cap')}`}
    </Button>
    <Select
      isClearable
      placeholder={`Filter By ${i18n.format(i18n.t('client'), 'cap')}`}
      value={clients.find((client => client.value === calendarSelectedUser))}
      onChange={e => (e ? onFilter(e.value) : onFilter(null))}
      options={clients}
      styles={{
        container: provided => ({
          ...provided,
          width: '200px',
          marginLeft: '20px',
          zIndex: 100,
        }),
        menu: provided => ({
          ...provided,
          marginTop: '1px',
        }),
      }}
    />
  </Flex>
);
